var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file [Please Input File Description]
 * @author (zhuwanying02) if any problem, please call me.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash-es';
import classnames from 'classnames';

import { inputLoop, getChineseLength, classPrefix } from '../../common/util';

import './Textarea.less';
/*
 * 参数说明
 * value                可选，默认值
 * onHandleChange       忽略，form专用，内部方法
 * id                   可选，唯一id
 * name                 可选，如果没有此项，会自动生成一个
 * increment            忽略，form专用，内部属性，唯一标识
 * formFlag             忽略，form专用，内部属性
 * getValue             可选，获取数据
 * max                  可选，最大输入字符个数
 * countFlag            可选，是否显示计数
 * countComplete        可选，是否完整显示计数(默认超过99会显示99+)
 * countWay             可选, 字数统计的展现形式length,character,characterInt。默认为length
 * onClick              可选，点击触发
 * horizontal           可选，水平排列
 * vertical             可选，垂直排列，默认垂直
 * noDistance           可选，此项为true，textarea下的24px消失
 * width                可选，自定义宽度，默认为400px
 * height               可选，自定义高度，默认为88px
 * className            可选，自定义class
 * style                可选，自定义样式
 * readOnly             可选，只读
 * noWarning            可选，不要提示警告
 * classPrefix          可选，class前缀
 * placeHolder          可选，placeholder
 * validate             可选，验证信息
 * disabled             可选，不可用态
 * label                可选，label说明
 * star                 可选，是否必填的*号
 * tips                 可选，后面的说明文字
 */

var Textarea = function (_Component) {
    _inherits(Textarea, _Component);

    function Textarea(props) {
        _classCallCheck(this, Textarea);

        var _this = _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props));

        var _this$props = _this.props,
            value = _this$props.value,
            id = _this$props.id,
            name = _this$props.name;
        // 若没传name,id; 则给默认值

        var loop = inputLoop();
        _this.__name = name ? name : loop;
        _this.__id = id ? id : loop;

        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;

        _this.formCallback(value, _this.FORM_NO_NEED_VALIDATE);

        _this.onBlurChange = _this.onBlurChange.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        return _this;
    }

    _createClass(Textarea, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.value, this.props.value)) {
                this.formCallback(np.value, this.FORM_NEED_VALIDATE);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.formCallback(this.props.value, this.FORM_NO_NEED_VALIDATE, true);
        }
    }, {
        key: 'formCallback',
        value: function formCallback(value) {
            var needValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.FORM_NEED_VALIDATE;
            var isDelete = arguments[2];
            var _props = this.props,
                formFlag = _props.formFlag,
                increment = _props.increment,
                onHandleChange = _props.onHandleChange;


            if (onHandleChange && formFlag && _.isFunction(onHandleChange)) {
                onHandleChange({
                    name: this.__name,
                    value: value
                }, this, needValidate, increment, isDelete);
            }
        }
    }, {
        key: 'onBlurChange',
        value: function onBlurChange(e) {
            var value = e.target.value;
            var onBlur = this.props.onBlur;

            if (onBlur && _.isFunction(onBlur)) {
                onBlur({
                    name: this.__name,
                    value: value
                });
            }
            this.formCallback(value, this.FORM_NEED_VALIDATE);
        }
    }, {
        key: 'getValueCount',
        value: function getValueCount(value) {
            var countWay = this.props.countWay;
            var len = 0;

            if (countWay === 'length') {
                len = value.length;
            } else if (countWay === 'character') {
                len = getChineseLength(value) * 1.0 / 2;
            } else if (countWay === 'characterInt') {
                len = Math.ceil(getChineseLength(value) * 1.0 / 2);
            }

            return len;
        }
    }, {
        key: 'renderCount',
        value: function renderCount() {
            var _classnames;

            var _props2 = this.props,
                countComplete = _props2.countComplete,
                max = _props2.max,
                classPrefix = _props2.classPrefix,
                value = _props2.value;


            var valueCount = this.getValueCount(value);

            var countClass = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-count', true), _defineProperty(_classnames, classPrefix + '-count-warning', valueCount > max), _classnames));

            if (countComplete) {
                return React.createElement(
                    'span',
                    { className: countClass },
                    valueCount + '/' + max
                );
            }
            return React.createElement(
                'span',
                { className: countClass },
                valueCount > 99 ? '99+' : valueCount + '/' + max
            );
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(e) {
            var value = e.target.value;
            var getValue = this.props.getValue;

            if (getValue && _.isFunction(getValue)) {
                getValue({
                    name: this.__name,
                    value: value
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames2, _classnames3, _classnames4, _classnames5;

            var _props3 = this.props,
                onClick = _props3.onClick,
                onMouseDown = _props3.onMouseDown,
                horizontal = _props3.horizontal,
                width = _props3.width,
                height = _props3.height,
                resize = _props3.resize,
                className = _props3.className,
                noWarning = _props3.noWarning,
                placeHolder = _props3.placeHolder,
                validate = _props3.validate,
                disabled = _props3.disabled,
                label = _props3.label,
                tips = _props3.tips,
                max = _props3.max,
                countFlag = _props3.countFlag,
                spellCheck = _props3.spellCheck,
                classPrefix = _props3.classPrefix,
                readOnly = _props3.readOnly,
                value = _props3.value,
                responsive = _props3.responsive,
                onCompositionStart = _props3.onCompositionStart,
                onCompositionEnd = _props3.onCompositionEnd,
                onCompositionUpdate = _props3.onCompositionUpdate;

            var textareaRootClass = classnames(className, (_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-textarea-root', true), _defineProperty(_classnames2, 'display-i-b', horizontal), _defineProperty(_classnames2, 'no-warning', noWarning), _defineProperty(_classnames2, 'responsive', responsive), _classnames2));
            var textareaBoxClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, classPrefix + '-textarea-box', true), _defineProperty(_classnames3, classPrefix + '-horizontal', horizontal), _defineProperty(_classnames3, classPrefix + '-no-distance', true), _classnames3));
            var textareaClass = classnames((_classnames4 = {}, _defineProperty(_classnames4, className, true), _defineProperty(_classnames4, classPrefix + '-textarea', true), _defineProperty(_classnames4, classPrefix + '-horizontal', horizontal), _defineProperty(_classnames4, classPrefix + '-no-distance', true), _defineProperty(_classnames4, classPrefix + '-textarea-border-waining', validate && validate.ret && validate.ret === -1 || this.getValueCount(value) > max), _classnames4));
            var labelClass = classnames((_classnames5 = {}, _defineProperty(_classnames5, classPrefix + '-label-textarea', true), _defineProperty(_classnames5, classPrefix + '-horizontal', horizontal), _defineProperty(_classnames5, classPrefix + '-no-distance', true), _classnames5));
            var warningStyle = label === null ? { paddingLeft: '10px' } : {};
            var textareaStyle = {
                width: responsive ? '100%' : width ? width : 'auto',
                height: height ? height : 'auto',
                resize: resize ? 'auto' : 'none'
            };

            return React.createElement(
                'div',
                { className: textareaRootClass },
                React.createElement(
                    'label',
                    { htmlFor: this.__id, className: labelClass },
                    label && React.createElement(
                        'div',
                        { className: classPrefix + '-form-label' },
                        label
                    ),
                    React.createElement(
                        'div',
                        { className: textareaBoxClass },
                        React.createElement('textarea', {
                            className: textareaClass,
                            spellCheck: spellCheck,
                            ref: this.__name,
                            style: textareaStyle,
                            disabled: disabled,
                            id: this.__id,
                            name: this.__name,
                            value: value,
                            placeholder: placeHolder,
                            onChange: this.handleInputChange,
                            onMouseDown: onMouseDown,
                            onClick: onClick,
                            onBlur: this.onBlurChange,
                            readOnly: readOnly,
                            onCompositionStart: onCompositionStart,
                            onCompositionEnd: onCompositionEnd,
                            onCompositionUpdate: onCompositionUpdate
                        }),
                        countFlag && this.renderCount(),
                        !noWarning && React.createElement(
                            'div',
                            { className: classPrefix + '-form-warning', style: warningStyle },
                            validate && validate.message ? React.createElement(
                                'span',
                                null,
                                React.createElement('i', { className: classPrefix + '-input-error' }),
                                validate.message
                            ) : ''
                        )
                    ),
                    tips && React.createElement(
                        'div',
                        { className: classPrefix + '-form-tips' },
                        tips
                    )
                )
            );
        }
    }]);

    return Textarea;
}(Component);

export default Textarea;

Textarea.defaultProps = {
    // base
    countWay: 'length',
    classPrefix: classPrefix,
    width: 400,
    height: '88',
    value: ''
};

Textarea.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    increment: PropTypes.any,
    noDistance: PropTypes.bool,
    noWarning: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rows: PropTypes.string,
    onClick: PropTypes.func,
    onHandleChange: PropTypes.func,
    getValue: PropTypes.func,
    className: PropTypes.string,
    tips: PropTypes.node,
    star: PropTypes.bool,
    classPrefix: PropTypes.string,
    placeHolder: PropTypes.string,
    validate: PropTypes.any,
    disabled: PropTypes.bool,
    label: PropTypes.node,
    errMessage: PropTypes.string,
    value: PropTypes.string,
    max: PropTypes.number,
    countFlag: PropTypes.bool,
    formFlag: PropTypes.bool,
    horizontal: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    resize: PropTypes.bool,
    countComplete: PropTypes.bool,
    countWay: PropTypes.string,
    spellCheck: PropTypes.bool,
    readOnly: PropTypes.bool,
    onBlur: PropTypes.func,
    onMouseDown: PropTypes.func,
    responsive: PropTypes.bool,
    onCompositionStart: PropTypes.func,
    onCompositionEnd: PropTypes.func,
    onCompositionUpdate: PropTypes.func
};